import { render, staticRenderFns } from "./VideoCallRoomContainer.vue?vue&type=template&id=34f7b425&scoped=true&"
import script from "./VideoCallRoomContainer.vue?vue&type=script&lang=ts&"
export * from "./VideoCallRoomContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7b425",
  null
  
)

export default component.exports